let baseUrl = 'https://seeroo.mn';
// let baseUrl = 'https://seeroo.test';

export default {
    HOST: baseUrl,
    IMG_HOST: baseUrl,
};